import React from "react";
import ReactDOM from "react-dom";
// @ts-ignore
import * as Sentry from "@sentry/react";
import { Auth0Provider } from "@auth0/auth0-react";

import App from "./App";
import "./styles/root.css";
import swDev from "./swDev";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import { BrandingProvider } from "./app/theme/BrandingProvider";

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID as string}
      authorizationParams={{
        redirect_uri: window.location.origin + "/home"
      }}
    >
    <ThemeProvider>
    <LanguageProvider>
      {/*
        Above App, and therefore above the router, so the guest screens are branded too:
        the join lobby, sign-in, sign-up, activation and feedback pages all render without a
        session and are outside both the redux Provider and the authenticated Layout.
      */}
      <BrandingProvider>
        <App />
      </BrandingProvider>
    </LanguageProvider>
    </ThemeProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
